import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href="https://vivetransforma.com/cart/51179539366183:1" target="_blank" rel="noopener noreferrer" onClick={onClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`relative inline-flex items-center justify-center bg-[#00c853] text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full text-center shadow-[0_0_25px_rgba(0,200,83,0.6)] hover:shadow-[0_0_35px_rgba(0,212,255,0.8)] transition-all duration-300 overflow-hidden group ${className}`} data-id="element-20">
      <span className="relative z-10" data-id="element-21">{children}</span>
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] skew-x-12 z-0" data-id="element-22"></div>
    </motion.a>;
}